import { render, staticRenderFns } from "./BrochureRental.vue?vue&type=template&id=42ed4fa6&scoped=true&"
import script from "./BrochureRental.vue?vue&type=script&lang=js&"
export * from "./BrochureRental.vue?vue&type=script&lang=js&"
import style0 from "./BrochureRental.vue?vue&type=style&index=0&id=42ed4fa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ed4fa6",
  null
  
)

export default component.exports